module.exports = __webpack_public_path__ + "static/media/Sleper_Aanvraag.22739053.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/01/assets/Sleper_Aanvraag.mp3
// module id = 547
// module chunks = 0